import React from 'react';
import './IndicatorsPanel.scss';

const IndicatorsPanel = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="indicators-panel">
      <button className="indicators-panel__close-button" onClick={onClose}>
        ✕
      </button>
      <h2 className="indicators-panel__title">Color Indicators</h2>
      <div className="indicators-panel__guide">
        <div className="indicators-panel__example indicators-panel__example--correct">
          <span className="indicators-panel__example-box"></span>
          <span className="indicators-panel__example-label">Correct</span>
        </div>
        <div className="indicators-panel__example indicators-panel__example--partial">
          <span className="indicators-panel__example-box"></span>
          <span className="indicators-panel__example-label">Partial</span>
        </div>
        <div className="indicators-panel__example indicators-panel__example--incorrect">
          <span className="indicators-panel__example-box"></span>
          <span className="indicators-panel__example-label">Incorrect</span>
        </div>
      </div>
    </div>
  );
};

export default IndicatorsPanel;